import { initAnimations } from './utils/animations';
import { initMenu } from './utils/menu';
import { initSearch } from './utils/search';

document.addEventListener('DOMContentLoaded', () => {
  // ─── Sticky header ───────────────────────────────────────────────────────
  const header = document.querySelector('.site-header');

  if (header) {
    const handleScroll = () => {
      header.classList.toggle('site-header--sticky', window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  // ─── Universal Animation & Parallax System ───────────────────────────────
  initAnimations();

  // ─── Off-canvas Menu ────────────────────────────────────────────────────
  initMenu();

  // ─── Search Drawer ──────────────────────────────────────────────────────
  initSearch();
});
